import { UiStackModel } from "../../models";

export function mockUiStackModel({
    id = "stack-1234",
    type = "uiStack",
    locale = "en",
    content = mockUiStackModelContent()
}: Partial<UiStackModel> = {}): UiStackModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiStackModelContent = UiStackModel["content"];

export function mockUiStackModelContent({
    title = "Example stack",
    spacing = "none",
    orientation = "horizontal",
    fullHeight = false,
    ...optionals
}: Partial<UiStackModelContent> = {}): UiStackModelContent {
    return {
        title,
        spacing,
        orientation,
        fullHeight,
        ...optionals
    };
}
